import { Accordion, AccordionTab } from "primereact/accordion";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { X } from "lucide-react";
import apiurl from "../../services/apiendpoint/apiendpoint";
import { apigetcourseName } from "../../services/courses/apicourses";

export default function Addandeditform ({visible, setVisible, formdata, handlesave, handleupdate, handlechange}) {

    const [maximized, setMaximized] = useState(true);
    const [sections, setSections] = useState([]);
    const [courseNames, setCourseNames] = useState([]);

    useEffect(() => {
        if (formdata.sections && formdata.sections.length > 0) {
            const sectionsWithIds = formdata.sections.map((section, sectionIndex) => {
                const sectionId = section.id || section._id?.$oid || section._id || `section-${Date.now()}-${sectionIndex}-${Math.random()}`;
                
                return {
                    ...section,
                    id: sectionId,
                    media_files: (section.media_files || []).map((media, mediaIndex) => {
                        const mediaId = media.id || media._id?.$oid || media._id || `media-${Date.now()}-${sectionIndex}-${mediaIndex}-${Math.random()}`;
                        
                        return {...media,id: mediaId};
                    })
                };
            });
            
            setSections(sectionsWithIds);
        } else {
            setSections([]);
        }
    }, [formdata._id, formdata.sections]);

    const handleQuillChange = (value) => {
        handlechange({target: {name: 'Description', value: value}});
    };

    const addSection = () => {
        const newSection = {
            id: `section-new-${Date.now()}-${Math.random()}`,
            sectionTitle: '',
            media_files: [] 
        };
        const updatedSections = [...sections, newSection];
        setSections(updatedSections);
        handlechange({target: {name: 'sections', value: updatedSections}});
    };

    const removeSection = (sectionId) => {
        console.log('Removing section:', sectionId);
        const updatedSections = sections.filter(section => section.id !== sectionId);
        setSections(updatedSections);
        handlechange({target: {name: 'sections', value: updatedSections}});
    };

    const updateSectionTitle = (sectionId, title) => {
        const updatedSections = sections.map(section =>
            section.id === sectionId ? { ...section, sectionTitle: title } : section
        );
        setSections(updatedSections);
        handlechange({target: {name: 'sections', value: updatedSections}});
    };

    const addMediaToSection = (sectionId) => {
        const updatedSections = sections.map(section => {
            if (section.id === sectionId) {
                return {
                    ...section,
                    media_files: [
                        ...(section.media_files || []),
                        {
                            id: `media-new-${Date.now()}-${Math.random()}`,
                            title: '',
                            file: null,
                            file_url: null,
                            file_type: 'pdf'
                        }
                    ]
                };
            }
            return section;
        });
        setSections(updatedSections);
        handlechange({ target: { name: 'sections', value: updatedSections } });
    };

    const removeMediaFromSection = (sectionId, mediaId) => {
        
        const updatedSections = sections.map(section => {
            if (section.id === sectionId) {
                return {
                    ...section,
                    media_files: section.media_files.filter(media => media.id !== mediaId)
                };
            }
            return section;
        });

        setSections(updatedSections);
        handlechange({ target: { name: 'sections', value: updatedSections } });
    };

    const updateMediaTitle = (sectionId, mediaId, title) => {
        const updatedSections = sections.map(section => {
            if (section.id === sectionId) {
                return {
                    ...section,
                    media_files: section.media_files.map(media =>
                        media.id === mediaId ? { ...media, title } : media
                    )
                };
            }
            return section;
        });
        setSections(updatedSections);
        handlechange({target: {name: 'sections', value: updatedSections}});
    };

    const updateMediaFileType = (sectionId, mediaId, fileType) => {
        
        const updatedSections = sections.map(section => {
            if (section.id === sectionId) {
                return {
                    ...section,
                    media_files: section.media_files.map(media => {
                        if (media.id === mediaId) {
                            return { ...media, file_type: fileType, file: null };
                        }
                        return media;
                    })
                };
            }
            return section;
        });

        setSections(updatedSections);
        handlechange({ target: { name: 'sections', value: updatedSections } });
    };

    const updateMediaFile = (sectionId, mediaId, file) => {
        if (!file) return;


        const updatedSections = sections.map(section => {
            if (section.id === sectionId) {
                return {
                    ...section,
                    media_files: section.media_files.map(media => {
                        if (media.id === mediaId) {
                            return { ...media, file, file_url: null };
                        }
                        return media;
                    })
                };
            }
            return section;
        });

        setSections(updatedSections);
        handlechange({ target: { name: 'sections', value: updatedSections } });
    };

    useEffect(() => {
        const fetchCourseNames = async () => {
            try {
                const data = await apigetcourseName();
                if (data && data.resdata) {
                    setCourseNames(data.resdata);
                }
            } catch (error) {
                console.error('Error fetching course names:', error);
            }
        };

        fetchCourseNames();
    }, []);

    return (
        <>
            <Dialog header="PYQ Form" visible={visible} onHide={() => { if (!visible) return; setVisible(false); }} style={{ width: "90vw" }} 
                    breakpoints={{ "960px": "95vw", "641px": "100vw" }} maximizable maximized={maximized} onMaximize={(e) => setMaximized(e.maximized)}>
                <form onSubmit={!formdata._id ? handlesave : handleupdate}>
                    <div className="p-4 mb-4 bg-gray-50 rounded-xl">
                        <div className="grid grid-cols-1 gap-5 md:grid-cols-3 lg:grid-cols-4">
                            <div>
                                <label className="font-medium">Cover Image</label>
                                <input type="file" name="Cover_image" className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" 
                                    onChange={handlechange} required={!formdata._id} />
                                {formdata.Cover_image && (
                                    <div className="mt-2">
                                        <img src={formdata.Cover_image instanceof File ? URL.createObjectURL(formdata.Cover_image) : `${apiurl()}/${formdata.Cover_image}`}  
                                            alt="Cover" className="object-cover w-16 h-16 border rounded-lg"/>
                                    </div>
                                )}
                            </div>
                            <div>
                                <label className="font-medium">Title</label>
                                <input type="text" name="Title" value={formdata["Title"] || ''} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" 
                                    onChange={handlechange} required />
                            </div>
                            <div className="col-span-2">
                                <label className="font-medium">Description</label>
                                <ReactQuill theme="snow" value={formdata['Description'] || ''} onChange={handleQuillChange} className="mt-1 bg-white rounded-xl" />
                            </div>
                            <div>
                                <label className="font-medium">Status</label>
                                <select name="Status" value={formdata["Status"] || ''} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" 
                                    onChange={handlechange} required>
                                    <option value="" disabled>--- Select status ---</option>
                                    <option value="Active">Active</option>
                                    <option value="Inactive">Inactive</option>
                                </select>
                            </div>
                            <div>
                                <label className="font-medium">Category</label>
                                <select name="Category" value={formdata["Category"] || ''} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" 
                                    onChange={handlechange} required>
                                    <option value="" disabled>--- Select status ---</option>
                                    {courseNames
                                        .filter(course => course.courseName && course.courseName.trim() !== '')
                                        .map((course) => (
                                            <option key={course._id} value={course.courseName}>
                                                {course.courseName}
                                            </option>
                                        ))}
                                </select>
                            </div>
                        </div>

                        <div className="p-4 mt-4 bg-blue-50 rounded-xl">
                            <div className="flex items-center justify-between mb-4">
                                <h3 className="text-lg font-semibold">Question Paper Sections</h3>
                                <button type="button" className="px-3 py-1 text-white bg-green-500 rounded-md" onClick={addSection}>Add Section</button>
                            </div>

                            <Accordion multiple>
                                {sections.map((section, sectionIndex) => (
                                    <AccordionTab key={section.id}
                                        header={
                                            <div className="flex items-center justify-between w-full">
                                                <span>{section.sectionTitle || `Section ${sectionIndex + 1}`}</span>
                                                <button type="button" className="px-4 py-1 text-white bg-red-500 rounded-lg" 
                                                    onClick={(e) => {
                                                        e.stopPropagation(); 
                                                        removeSection(section.id);
                                                    }}>
                                                    <X/>
                                                </button>
                                            </div>
                                        }
                                    >
                                        <div className="space-y-4">
                                            <div>
                                                <label className="font-medium">Section Title (e.g., NEET 2025)</label>
                                                <input type="text" value={section.sectionTitle} onChange={(e) => updateSectionTitle(section.id, e.target.value)}
                                                    className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" placeholder="Enter section title" required
                                                />
                                            </div>

                                            <div className="p-4 bg-white rounded-xl">
                                                <div className="flex items-center justify-between mb-3">
                                                    <h4 className="font-medium">Media Files</h4>
                                                    <button type="button" className="px-3 py-1 text-white bg-green-500 rounded-md" 
                                                        onClick={() => addMediaToSection(section.id)}>Add File</button>
                                                </div>

                                                {section.media_files.length === 0 ? (
                                                    <p className="py-4 text-center text-gray-500">No files added yet</p>
                                                ) : (
                                                    <div className="">
                                                        {section.media_files.map((media, mediaIndex) => (
                                                            <div key={media.id} className="flex items-end gap-3 p-3 mb-3 rounded-lg bg-gray-50">
                                                                <div className="flex-1">
                                                                    <label className="text-sm font-medium">File Type</label>
                                                                    <select value={media.file_type} 
                                                                        onChange={(e) => updateMediaFileType(section.id, media.id, e.target.value)}
                                                                        className="w-full px-3 py-2 mt-1 border rounded-lg outline-none" required>
                                                                        <option value="pdf">PDF</option>
                                                                        <option value="video">Video</option>
                                                                    </select>
                                                                </div>
                                                                <div className="flex-1">
                                                                    <label className="text-sm font-medium">Title</label>
                                                                    <input type="text" value={media.title} onChange={(e) => updateMediaTitle(section.id, media.id, e.target.value)}
                                                                        className="w-full px-3 py-2 mt-1 border rounded-lg outline-none" placeholder="e.g., Paper 1" required />
                                                                </div>
                                                                <div className="flex-1">
                                                                    <label className="text-sm font-medium">
                                                                        {media.file_type === 'pdf' ? 'PDF File' : 'Video File'}
                                                                    </label>
                                                                    <input type="file" accept={media.file_type === 'pdf' ? '.pdf' : 'video/*'} 
                                                                        onChange={(e) => updateMediaFile(section.id, media.id, e.target.files[0])}
                                                                        className="w-full px-3 py-2 mt-1 border rounded-lg outline-none" />
                                                                    
                                                                    {(media.file || media.file_url) && (
                                                                        <div className="p-2 mt-2 rounded-lg bg-blue-50">
                                                                            <div className="mb-1 text-xs text-gray-500">Current File:</div>
                                                                            {media.file ? (
                                                                                <div className="flex items-center gap-2">
                                                                                    <span className="px-2 py-1 text-xs font-medium text-white bg-green-600 rounded">
                                                                                        {media.file_type.toUpperCase()}
                                                                                    </span>
                                                                                    <span className="text-sm text-gray-700 truncate">{media.file.name}</span>
                                                                                </div>
                                                                            ) : (
                                                                                <a href={`${apiurl()}/${media.file_url}`} 
                                                                                target="_blank" 
                                                                                rel="noopener noreferrer"
                                                                                className="flex items-center gap-2 hover:underline">
                                                                                    <span className="px-2 py-1 text-xs font-medium text-white bg-blue-600 rounded">
                                                                                        {media.file_type.toUpperCase()}
                                                                                    </span>
                                                                                    <span className="text-sm text-gray-700 truncate">
                                                                                        {media.file_url.split('/').pop()}
                                                                                    </span>
                                                                                </a>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <button type="button" className="p-1 mb-2 text-white bg-red-500 rounded-full" 
                                                                    onClick={() => removeMediaFromSection(section.id, media.id)}>
                                                                    <X/>
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </AccordionTab>
                                ))}
                            </Accordion>

                            {sections.length === 0 && (
                                <p className="py-8 text-center text-gray-500">No sections added yet. Click "Add Section" to begin.</p>
                            )}
                        </div>

                        <div className="flex justify-end gap-3 mt-4">
                            <button type="button" onClick={() => setVisible(false)} className="px-4 py-1 bg-gray-200 rounded-lg">Cancel</button>
                            <button type="submit" className="px-4 py-1 text-white rounded-lg bg-regal-blue">{!formdata._id ? "Save" : "Update"}</button>
                        </div>
                    </div>
                </form>
            </Dialog>
        </>
    )
}